import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSignal } from "@preact/signals";
import Button from "../../Button";
import TextInput from "../../Form/TextInput";
import Icon from "../../Icon";
import DropDownMenu from "../../DropDownMenu";
import TextArea from "../../Form/TextArea";
import MessageBox from "../../MessageBox";
import style from "./style.module.scss";
export default function URLList(props) {
    const { urlData, addURL, removeURL, updateURLData, error, urlErrors, scriptError, scriptErrors, onFullScreenMode } = props;
    function updateData() {
        updateURLData(urlData);
    }
    let errorMessage = "";
    if (error) {
        errorMessage = error;
    }
    if (scriptError) {
        errorMessage += " " + scriptError;
    }
    return (_jsxs("div", { className: style["url-list"], children: [urlData.map((urlDetail, index) => {
                return (_jsx(URLItem, { onRemove: removeURL, urlDetails: urlDetail, onFullScreenMode: onFullScreenMode, onUpdateURLData: updateData, error: urlErrors[index], scriptError: scriptErrors[index] }, urlDetail.id));
            }), _jsx(Button, { variation: "primary-inline", onClick: () => {
                    addURL();
                }, children: "Add URL" }), errorMessage ? _jsx(MessageBox, { type: "error", children: errorMessage }) : null] }));
}
function URLItem(props) {
    const { onRemove, urlDetails, onUpdateURLData, onFullScreenMode, error, scriptError } = props;
    const scriptTemplates = [
        {
            options: [
                { label: "Repeat View", value: "repeat-view" },
                { label: "Block Third Party", value: "block-third-party" },
                { label: "PWA: Repeat view while offline", value: "pwa-repeat-view-while-offline" },
                { label: "Don't add 'PTST' to user agent", value: "dont-add-ptst" },
            ],
        },
    ];
    let defaultDisplayBasicAuth = false;
    if (urlDetails.basicAuth && urlDetails.basicAuth.username) {
        defaultDisplayBasicAuth = true;
    }
    let defaultDisplayScript = false;
    if (urlDetails.script && urlDetails.script.length > 0) {
        defaultDisplayScript = true;
    }
    const displayScript = useSignal(defaultDisplayScript);
    const displayBasicAuth = useSignal(defaultDisplayBasicAuth);
    const selectedScript = useSignal(undefined);
    const scriptRowNum = useSignal(4);
    function injectScript(scriptOption) {
        //Extract the domain from the url entered.
        let domain = "";
        //find & remove protocol (http, ftp, etc.) and get domain
        if (urlDetails.urlPath.indexOf("://") > -1) {
            domain = urlDetails.urlPath.split("/")[2];
        }
        else {
            domain = urlDetails.urlPath.split("/")[0];
        }
        //find & remove port number
        domain = domain.split(":")[0];
        switch (scriptOption) {
            case "repeat-view":
                urlDetails.script =
                    "// Repeat View\nlogData\t0\nnavigate\t" +
                        urlDetails.urlPath +
                        '\nexec\tdocument.body.innerHTML=""\nsleep\t2\nlogData\t1\nnavigate\t' +
                        urlDetails.urlPath;
                break;
            case "block-third-party":
                urlDetails.script =
                    "// Block third party\nblockDomainsExcept\t" + domain + "\nnavigate\t" + urlDetails.urlPath;
                break;
            case "pwa-repeat-view-while-offline":
                urlDetails.script =
                    "// PWA: Repeat view while offline\nlogData\t0\nnavigate\t" +
                        urlDetails.urlPath +
                        '\nexec\tdocument.body.innerHTML=""\nsleep\t2\nlogData\t1\nblockDomainsExcept\tunused.zz\nnavigate\t' +
                        urlDetails.urlPath;
                break;
            case "dont-add-ptst":
                urlDetails.script =
                    "// Remove 'PTST' from user agent\nspeedcurve_removePTST\t1\nnavigate\t" + urlDetails.urlPath;
                break;
        }
        onUpdateURLData();
    }
    if (!urlDetails.basicAuth) {
        urlDetails.basicAuth = { username: "", password: "" };
    }
    return (_jsxs("div", { className: style["url-list__item"], children: [_jsxs("div", { className: style["url-list__item__url"], children: [_jsx(TextInput, { placeholder: "URL", customClass: style["url-list__item__url__input"], onBlur: (event) => {
                            urlDetails.urlPath = event.currentTarget.value;
                            onUpdateURLData();
                        }, onKeyDown: (event) => {
                            if (event.code === "Enter") {
                                urlDetails.urlPath = event.currentTarget.value;
                                onUpdateURLData();
                            }
                        }, defaultValue: urlDetails.urlPath, type: "url", error: error }, urlDetails.id), _jsx(Button, { variation: "tertiary-inline", title: "Basic Auth", onClick: () => {
                            displayBasicAuth.value = !displayBasicAuth.value;
                        }, children: _jsx(Icon, { name: "lock" }) }), _jsx(Button, { variation: "tertiary-inline", onClick: () => {
                            displayScript.value = !displayScript.value;
                        }, title: "Script", children: _jsx(Icon, { name: "code" }) }), _jsx(Button, { variation: "tertiary-inline", title: "Delete", onClick: () => {
                            onRemove(urlDetails);
                        }, children: _jsx(Icon, { name: "xmark" }) })] }), displayBasicAuth.value === true && (_jsxs("div", { className: style["url-list__item__basic-auth"], children: [_jsx(TextInput, { customClass: style["url-list__item__basic-auth__username"], placeholder: "Basic Auth Username", defaultValue: urlDetails.basicAuth.username, onBlur: (event) => {
                            if (urlDetails.basicAuth) {
                                urlDetails.basicAuth.username = event.currentTarget.value;
                            }
                            onUpdateURLData();
                        } }), _jsx(TextInput, { customClass: style["url-list__item__basic-auth__password"], placeholder: "Basic Auth Password", defaultValue: urlDetails.basicAuth.password, onBlur: (event) => {
                            if (urlDetails.basicAuth) {
                                urlDetails.basicAuth.password = event.currentTarget.value;
                            }
                            onUpdateURLData();
                        }, type: "password" })] })), (displayScript.value === true || scriptError === true) && (_jsxs("div", { className: style["url-list__item__scripts"], children: [_jsxs("div", { className: style["url-list__item__scripts__script-help"], children: [_jsx(DropDownMenu, { selected: selectedScript.value, sections: scriptTemplates, onChange: (menuOption) => {
                                    selectedScript.value = menuOption.value;
                                    injectScript(menuOption.value);
                                }, placeholder: "Script Templates", displayType: "text-input" }), _jsxs("div", { className: style["url-list__item__scripts__script-help__right-options"], children: [_jsx("a", { href: "https://support.speedcurve.com/docs/synthetic-test-scripts", children: "Scripting Docs" }), scriptRowNum.value === 4 ? (_jsxs(Button, { className: style["url-list__item__scripts__script-help__icon"], variation: "secondary-inline", onClick: () => {
                                            scriptRowNum.value = 15;
                                            onFullScreenMode(true);
                                        }, children: ["Fullscreen Mode", _jsx(Icon, { name: "expand" })] })) : (_jsxs(Button, { className: style["url-list__item__scripts__script-help__icon"], variation: "secondary-inline", onClick: () => {
                                            scriptRowNum.value = 4;
                                            onFullScreenMode(false);
                                        }, children: ["Exit Fullscreen Mode", _jsx(Icon, { name: "contract" })] }))] })] }), _jsx(TextArea, { placeholder: "Test Script", value: urlDetails.script, rows: scriptRowNum.value, error: scriptError, code: true, onBlur: (event) => {
                            urlDetails.script = event.currentTarget.value;
                            onUpdateURLData();
                        } }, urlDetails.id + "script")] }))] }));
}
